import React from 'react';
import { X } from 'lucide-react';
import './BulkActionBar.css';

/**
 * BulkActionBar — фиксированная панель внизу при множественном выборе.
 *
 * Props:
 *   count     - количество выбранных элементов
 *   onClear   - сброс выбора
 *   children  - кнопки действий
 */
export function BulkActionBar({ count = 0, onClear, children }) {
  if (count === 0) return null;

  return (
    <div className="ui-bulk-bar">
      <div className="ui-bulk-bar__inner">
        <div className="ui-bulk-bar__info">
          <span className="ui-bulk-bar__count">{count}</span>
          <span className="ui-bulk-bar__label">
            {count === 1 ? 'элемент выбран' : count < 5 ? 'элемента выбрано' : 'элементов выбрано'}
          </span>
          {onClear && (
            <button className="ui-bulk-bar__clear" onClick={onClear}>
              <X size={14} />
              Сбросить
            </button>
          )}
        </div>
        <div className="ui-bulk-bar__actions">
          {children}
        </div>
      </div>
    </div>
  );
}
